import Vue from 'vue';
import VueRouter from 'vue-router';
import { routerHelpers } from '@codehq/aurora-app-core';

import modules from '../modules';

const AuthHome = () => import(/* webpackChunkName: "route-AuthHome" */'../views/AuthHome.vue');
const Login = () => import(/* webpackChunkName: "route-Login" */'../views/Login.vue');
const FeedbackItems = () => import(/* webpackChunkName: "route-Welcome" */'../views/FeedbackItems.vue');
// const Register = () => import(/* webpackChunkName: "route-Register" */'../views/Register.vue');
const Welcome = () => import(/* webpackChunkName: "route-Welcome" */'../views/Welcome.vue');
const UserManagementHome = () => import(/* webpackChunkName: "route-UserManagementHome" */'../views/UserManagementHome.vue');

Vue.use(VueRouter);

const appRoutes = [
  {
    path: '/',
    name: 'Welcome',
    component: Welcome,
  },
  {
    path: '/auth/login',
    alias: '/login',
    name: 'auth-Login',
    component: Login,
  },
  // {
  //   path: '/auth/register',
  //   alias: '/register',
  //   name: 'auth-Register',
  //   component: Register,
  // },
  {
    path: '/home',
    name: 'AuthHome',
    component: AuthHome,
  },
  {
    path: '/admin/feedbackItems',
    name: 'admin-FeedbackItems',
    component: FeedbackItems,
  },
  {
    path: '/admin/users',
    name: 'admin-UserManagementHome',
    component: UserManagementHome,
  },
];

const moduleRoutes = modules.map((m) => routerHelpers.mapViews(m.config.path, m.views));

const routes = [...appRoutes, ...moduleRoutes.flat()];

const router = new VueRouter({
  routes,
});

export { routes };
export { router };
